import { DateTime } from 'luxon'

import { ExplorerHomeInfo } from '~/api/repository'
import { IHomeExplorerCard } from '~/components/@pages/home/HomeExplorerCard.vue'
import { CHAIN, UNIT } from '~/constants/default.constants'

export class CHomeExplorer {
  private readonly _totalSupply: string
  private readonly _activeValidators: string
  private readonly _activelyStaked: string
  private readonly _currentBlockHeight: string
  private readonly _totalTransactionCount: string
  private readonly _totalTransactionList: {
    DT: string
    CNT: number
  }[]
  private readonly _unit: string
  private readonly _chartDataName: string

  constructor (data: ExplorerHomeInfo, chartDataName: string) {
    this._totalSupply = data.TTSP
    this._activeValidators = data.ATV
    this._activelyStaked = data.ATS
    this._currentBlockHeight = data.LBNO
    this._totalTransactionCount = data.TTRXCNT
    this._totalTransactionList = data.CNTLIST
    this._unit = UNIT
    this._chartDataName = chartDataName
  }

  getTotalSupply () {
    return setComma(parseInt(this._totalSupply))
  }

  getActiveValidators () {
    return setComma(this._activeValidators)
  }

  getActivelyStaked () {
    return setComma(parseInt(this._activelyStaked))
  }

  getCurrentBlockHeight () {
    return this._currentBlockHeight
  }

  getTotalTransactionCount () {
    return setComma(this._totalTransactionCount)
  }

  getTotalTransactionList () {
    return [
      {
        name: this._chartDataName,
        type: 'area',
        yAxis: 1,
        unit: '',
        stacking: '',
        decimalPoint: 2,
        data: this._totalTransactionList.map((item) => {
          return {
            day: DateTime.fromFormat(item.DT, 'yyyyMMdd').toFormat('yyyy-MM-dd'),
            value: Number(item.CNT)
          }
        })
      }
    ]
  }

  getUnit () {
    return this._unit
  }

  getViewModel (): IHomeExplorerCard[] {
    return [
      {
        iconName: 'toll',
        label: `${CHAIN} Asset Total Supply`,
        value: this.getTotalSupply(),
        unit: this.getUnit(),
      },
      {
        iconName: 'dns',
        label: 'Active Validators',
        value: this.getActiveValidators(),
      },
      {
        iconName: 'savings',
        label: 'Actively Staked',
        value: this.getActivelyStaked(),
        unit: this.getUnit(),
      },
      {
        iconName: 'view_in_ar',
        label: 'Current Block Height',
        value: this.getCurrentBlockHeight(),
      }
    ]
  }
}